import storage from '@api/storage';
import axios from 'axios';

const instance = axios.create({ baseURL: process.env.REACT_APP_TOS_API_URL });

class Tos {
  getToken() {
    return storage.token;
  }

  getAuthHeaders() {
    return { 'x-api-key': this.getToken() };
  }

  async login(username: string, password: string): Promise<string> {
    let response;
    try {
      response = await instance.post('/auth/sign-in', { id: username, password, type: 'customer' });
    } catch (err) {
      console.error(err);
    }
    if (!response?.data?.api_key) throw new Error('auth_failed');
    return response.data.api_key;
  }

  async getServiceTypes(): Promise<string[]> {
    try {
      const { data } = await instance.get('/symbol/service-types', { headers: this.getAuthHeaders() });
      return data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }
}

export default new Tos();
